import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AiBenchmarksInfographic = () => {
  return (
    <div className="vai-flex vai-flex-col vai-w-[1000px] vai-gap-4 ">
      <div className="vai-flex vai-flex-row vai-justify-between">
        <div className="vai-flex vai-flex-col vai-gap-6 vai-w-[30%]">
          <span className="vai-typography-h4 vai-text-[18px]">
            AI Benchmarks
          </span>
          <span>
            Benchmarks let you see the distribution of AI usage and acceptance
            across all providers in your entire organization.
          </span>
          <span>
            Benchmarks will also help you understand how a specific practice or
            provider is performing compared to the organization.
          </span>
        </div>
        <div className="vai-flex vai-flex-col vai-w-[60%]">
          <img
            src="/assets/images/insights/newAiRecommendationFunnel.png"
            alt="AI Benchmarks"
          />
        </div>
      </div>
      <span className="vai-border-b-[1px] vai-border-gray-200" />
      <span className="vai-typography-muted">METRIC GLOSSARY</span>
      <div className="vai-flex vai-flex-row vai-gap-2 vai-w-full">
        <div className="vai-flex vai-flex-row vai-gap-2">
          <span className="vai-bg-zinc-700 vai-text-white vai-rounded-full vai-text-sm vai-flex vai-items-center vai-justify-center vai-w-6 vai-h-6">
            A
          </span>
          <div className="vai-flex vai-flex-col vai-gap-2 vai-w-[205px]">
            <div className="vai-flex vai-flex-row vai-items-center vai-gap-4">
              <span className="vai-font-[500]">Conversion Rate</span>

              <FontAwesomeIcon
                icon={faStar}
                className="vai-h-5 vai-w-5 vai-text-chart-normal-1"
              />
            </div>
            <span className="vai-text-sm">
              The portion of total AI recommendations that went on to be
              completed.
            </span>
            <span className="vai-font-[500] vai-text-sm">
              Completed ÷ Total AI Recommendations
            </span>
            <span className="vai-typography-muted vai-italic vai-text-sm">
              Ex. If the AI surfaced 100 opportunities and 32 were completed,
              your conversion rate is 32%.
            </span>
          </div>
        </div>

        <span className="vai-border-r-[1px] vai-border-gray-200 vai-h-full" />

        <div className="vai-flex vai-flex-row vai-gap-2 ">
          <span className="vai-bg-zinc-700 vai-text-white vai-rounded-full vai-text-sm vai-flex vai-items-center vai-justify-center vai-w-6 vai-h-6">
            B
          </span>
          <div className="vai-flex vai-flex-col vai-gap-2 vai-w-[205px]">
            <span className="vai-font-[500]">Planned Rate</span>
            <span className="vai-text-sm">
              The percent of total AI recommendations that were treatment
              planned by a provider
            </span>
            <span className="vai-font-[500] vai-text-sm">
              Treatment Planned ÷ Total AI Recommendations
            </span>
            <span className="vai-typography-muted vai-italic vai-text-sm">
              Ex. If the AI surfaced 100 opportunities and the provider planned
              60, your planned rate is 60%.
            </span>
          </div>
        </div>

        <span className="vai-border-r-[1px] vai-border-gray-200 vai-h-full" />

        <div className="vai-flex vai-flex-row vai-gap-2">
          <span className="vai-bg-zinc-700 vai-text-white vai-rounded-full vai-text-sm vai-flex vai-items-center vai-justify-center vai-w-6 vai-h-6">
            C
          </span>
          <div className="vai-flex vai-flex-col vai-gap-2 vai-w-[205px]">
            <span className="vai-font-[500]">Scheduled Rate</span>
            <span className="vai-text-sm">
              The portion of planned AI recommendations that were scheduled
            </span>
            <span className="vai-font-[500] vai-text-sm">
              Scheduled ÷ Planned AI Recommendations
            </span>
            <span className="vai-typography-muted vai-italic vai-text-sm">
              Ex. If you planned 60 AI opportunities and 40 were scheduled, your
              scheduled rate is 40 / 60 = 67%.
            </span>
          </div>
        </div>

        <span className="vai-border-r-[1px] vai-border-gray-200 vai-h-full" />

        <div className="vai-flex vai-flex-row vai-gap-2">
          <span className="vai-bg-zinc-700 vai-text-white vai-rounded-full vai-text-sm vai-flex vai-items-center vai-justify-center vai-w-6 vai-h-6">
            D
          </span>
          <div className="vai-flex vai-flex-col vai-gap-2 vai-w-[205px]">
            <span className="vai-font-[500]">Completed Rate</span>
            <span className="vai-text-sm">
              The portion of scheduled AI opportunities that were completed.
            </span>
            <span className="vai-font-[500] vai-text-sm">
              Completed ÷ Scheduled AI Recommendations
            </span>
            <span className="vai-typography-muted vai-italic vai-text-sm">
              Ex. If you scheduled 40 AI opportunities and 32 of those were
              completed, your completion rate is 32/40=80%.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
